import { render, staticRenderFns } from "./CompanySettingsPage.vue?vue&type=template&id=9ed4b0c0&"
import script from "./CompanySettingsPage.vue?vue&type=script&lang=js&"
export * from "./CompanySettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports